import { Button, IconAddUser, IconPlus } from '@gmg/gmg-react-components';
import { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import AppContext, { Role } from '../../AppContext';
import { UserModalState } from './AddOrEditUserModal';
import AddOrEditUserModalContainer from './AddOrEditUserModalContainer';
import { ModuleLicense } from 'src/viewModels/Organization';
import { ModuleId } from 'src/graphql/mappers/module';
import { AddOrEditUserSubmitData } from './UserManagement';
import { LicenseSystem } from 'src/viewModels/LicenseSystem';

export interface InviteUserBtnProps {
    orgId: string;
    maintainableRoles: Array<Role>;
    availableGroups: Map<string, string>;
    availableModules: Map<ModuleId, ModuleLicense>;
    onHandleInviteUser: (
        userData: AddOrEditUserSubmitData,
        setUsermodalState: (props: UserModalState) => void,
        onClose: () => void
    ) => void;
    availableLicenseSystems: LicenseSystem[];
};

const InviteUserBtn: FC<InviteUserBtnProps> = (props) => {
    const { t } = useTranslation();
    const context = useContext(AppContext);

    const handleInviteUserBtnClick = () => {
        context.onShowModal('inputModal', {
            title: t('AddUserBtn.addUser_Modal_title', 'Invite user'),
            titleIcon: <IconAddUser />,
            content: <AddOrEditUserModalContainer
                maintainableRoles={props.maintainableRoles}
                availableGroups={props.availableGroups}
                availableModules={props.availableModules}
                onHandleInviteUser={props.onHandleInviteUser}
                availableLicenseSystems={props.availableLicenseSystems}
            />,
        });
    };

    return (
        <Button
            variant="primary"
            icon={<IconPlus />}
            onClick={handleInviteUserBtnClick}
        >
            {t('AddUserBtn.button_title', 'Invite user')}
        </Button>
    );
};

export default InviteUserBtn;